export const SEARCH_HISTORY_STORAGE_KEY = 'searchHistory';

export default function persistSearchHistoryPlugin(store) {
  store.subscribe((mutation, state) => {
    if (mutation.type.startsWith('searchHistory')) {
      localStorage.setItem(
        SEARCH_HISTORY_STORAGE_KEY,
        JSON.stringify(state.searchHistory.historyList)
      );
    }
  });
}
